import Vue from 'vue';
import Errors from '@/library/Errors';

export default class Request {
  /**
   * Request constructor
   */
  constructor () {
    this.error = false;
    this.errors = new Errors();
    this.loading = false;
    this.success = false;
  }

  /**
   * Send a GET request to the given URL
   *
   * @param url
   * @returns {Promise<unknown>}
   */
  get (url) {
    return this.submit('get', url);
  }

  /**
   * Send a POST request to the given URL
   *
   * @param url
   * @param data
   * @returns {Promise<unknown>}
   */
  post (url, data) {
    return this.submit('post', url, data);
  }

  /**
   * Send a DELETE request to the given URL
   *
   * @param url
   * @returns {Promise<unknown>}
   */
  delete (url) {
    return this.submit('delete', url);
  }

  /**
   * Builds the url.
   *
   * @param url
   * @returns {string}
   */
  buildUrl(url) {
    return process.env.VUE_APP_ACC_URL.replace(/\/$/, '') + '/' + url.replace(/^\//, '');
  }

  /**
   *  Submit a request and return the promise.
   *
   * @param type
   * @param url
   * @param data
   * @returns {Promise<unknown>}
   */
  submit (type, url, data) {
    this.error = false;
    this.loading = true;
    this.success = false;

    let parameters = [
      this.buildUrl(url),
    ];

    if (['get', 'delete'].indexOf(type) === -1) {
      parameters.splice(1, 0, data);
    }

    return new Promise((resolve, reject) => {
      Vue.http[type](...parameters)
        .then(response => {
          this.onSuccess(response.data);

          resolve(response.data);
        }).catch(response => {
          if (!response.data || typeof response.data === 'string') {
            response.data = {
              message: response.data,
            };
          }

          response.data = this.onError(response.data);

          reject(response.data);
        });
    });
  }

  /**
   * When a request has been successful
   */
  onSuccess () {
    this.success = true;
    this.loading = false;
  }

  /**
   * When a request has received an error.
   *
   * @param {Object} data
   * @returns {{errors}|*}
   */
  onError (data) {
    this.error = true;
    this.loading = false;

    this.errors.parse(data);

    data.errors = this.errors;

    return data;
  }
}
